import moment from 'moment'

const HOOK_CSV_HEADERS = ['Hook', 'Total Ads', 'Active Ads', 'Longest Running (days)', 'Ad Names', 'Link URLs']

function slugify (str) {
  if (!str) return 'hooks'
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
}

function escapeCSV (value) {
  if (value === null || value === undefined) return ''
  const str = String(value)
  if (str.includes('"') || str.includes(',') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

function computeHookLiveDays (longestRunningAd) {
  if (!longestRunningAd?.startedRunning) return 'N/A'

  let endTime
  if (longestRunningAd.end_date && !isNaN(longestRunningAd.end_date._seconds)) {
    endTime = longestRunningAd.end_date._seconds * 1000
  } else {
    endTime = new Date().getTime()
  }

  const startDate = moment.utc(longestRunningAd.startedRunning)
  const endDate = moment.utc(endTime)
  const runningDuration = Math.ceil(moment.duration(endDate.diff(startDate)).as('days'))

  if (runningDuration < 0) return 'N/A'
  return runningDuration === 0 ? '<1' : String(runningDuration)
}

function getGroupAds (group) {
  if (Array.isArray(group.ads) && group.ads.length) return group.ads

  const dedupe = new Map()
  ;[group.longestRunningAd, group.mostRecentAd].forEach((ad) => {
    if (ad && !dedupe.has(ad.id)) dedupe.set(ad.id, ad)
  })
  return Array.from(dedupe.values())
}

export function exportHooksCSV (groups, { brandName = 'hooks' } = {}) {
  const rows = [HOOK_CSV_HEADERS]

  groups.forEach((group) => {
    const liveDays = computeHookLiveDays(group.longestRunningAd)
    const ads = getGroupAds(group)
    const adNames = ads
      .map((a) => a.name)
      .filter(Boolean)
      .join(' | ')
    const linkUrls = ads
      .map((a) => a.link_url)
      .filter(Boolean)
      .join(' | ')

    rows.push([
      group.displayHook || '',
      String(group.totalAds || 0),
      String(group.activeAds || 0),
      liveDays,
      adNames,
      linkUrls
    ])
  })

  const csv = rows.map((row) => row.map(escapeCSV).join(',')).join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  const filename = `${slugify(brandName)}-hooks.csv`
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

export async function copyHooksAsText (groups) {
  const text = groups
    .map((g) => g.displayHook?.trim())
    .filter(Boolean)
    .join('\n')

  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (error) {
    console.error('Error copying to clipboard:', error)
    return false
  }
}
